import { TableColumn } from "@shared/types/table";

export interface MeterCount {
  id: number;
  meterScheduleId: number;
  createdDate: string;
  startDate: string;
  endDate: string;
  meterCycleName: string;
  productCode: string[];
  meterType: string;
  meterCycleId: number;
  route: string[];
  newMeterCount: number;
  totalReadingCount: number;
  passCount: number;
  revisitCount: number;
  newCount: number;
  exemptionCount: number;
  pendingCount: number;
  duplicateCount: number;
}

export type ReadingImageItem = {
  readingImage: string;
  name: string;
  readingId: number | string;
};

export interface ViewReading {
  id: number;
  meterNumber: string;
  updatedOn: string;
  meterReading: number;
  ruleStatus: string;
  previousReading: number | null;
  previousReadingDate: string | null;
  consumption: number;
  accountNumber: string;
  consumerName: string;
  validatorId: number | null;
  cycleId: number;
  reasonCode: string | null;
  jobCardId: number;
  status: number;
}

export interface ViewReadingListResponse {
  pageNumber: number;
  count: number;
  next: string | null;
  previous: string | null;
  results: ViewReading[];
}

export interface NewReadingsResult {
  id: number;
  meter: string;
  jobCard: string;
  meterReading: number;
  meterNumber: string;
  updatedOn: string;
  readingTime: string;
  lat: number;
  long: number;
  deviceNo: string;
  cycleId: number;
  status: number;
  statusDisplay: string;
  validatorId: number | null;
}

export interface NewReadingsList {
  pageNumber: number;
  count: number;
  next: string;
  previous: string;
  results: NewReadingsResult[];
}

export interface RouteItem {
  id: number;
  routeName: string;
  premises: string[];
}

export interface MissingReading {
  id: number;
  remoteUtilityId: number;
  meterNumber: string;
  createdDate: string;
  previousReading: number | null;
  previousReadingDate: string | null;
  accountNumber: string;
  consumerName: string;
  validatorId: number | null;
  cycleId: number;
}

export interface MissingReadingsResponse {
  pageNumber: number;
  count: number;
  next: string | null;
  previous: string | null;
  results: MissingReading[];
}

export interface ValidatorInfo {
  validatorId: number;
  validatorName: string;
}

export interface ValidationBreakReadingItem {
  id: number;
  meter: number;
  jobCard: number;
  meterReading: number;
  ruleStatus: string;
  productCode: string;
  createdDate: string;
  readingTime: string | null;
  meterReader: number;
  lat: string | null;
  long: string | null;
  createdUserRemoteName: string | null;
  lastModifiedUserRemoteName: string | null;
  updatedOn: string;
  lastModifiedDate: string;
  validationCode: string | null;
  validationCodeDisplay: string | null;
  previousMeterReading: number;
  previousReadingDate: string;
  premise: string;
  meterNumber: string;
  deviceNo: string;
  meterReaderName: string;
  meterType: string;
  cycleId: number;
  routeName: string;
  validator: ValidatorInfo;
  createdTime: string;
  updatedOnTime: string;
  previousReading: number;
  consumption: number;
  premiseName: string;
  accountNumber: string;
  consumerName: string[]; // assuming it's always array of strings
  reasonCode: string | null;
}
export interface ExemptionsReadingResponse {
  pageNumber: number;
  count: number;
  next: string | null;
  previous: string | null;
  results: ValidationBreakReadingItem[];
}

export interface ValidatorDetail {
  validatorId: number | null;
  validatorName: string | null;
  contactNo: string | null;
  email: string | null;
}
export interface MeterReadingDetail {
  id: number;
  remoteUtilityId: string;
  meterNumber: string;
  deviceNo: string;
  productCode: string;
  premise: string;
  subArea: string;
  area: string;
  physicalStatus: string;
  ownershipDisplay: string;
  status: string;
  meterDials: any;
  meterMake: string;
  category: string;
  subCategory: string;
  meterType: number;
  lat: string;
  long: string;
  meterTypeDisplay: string;
  resourceTypeDisplay: string;
  resourceSubTypeDisplay: string;
  readingStatusDisplay: string;
  installedOn: string;
  installationPeriod: string;
  meterReaderDetails: {
    meterReaderName: string;
    contactNo: string;
    createdDate: string;
    joiningDate: string | null;
  };
  meterReader: {
    id:string
    name: string;
    email: string;
    contactNumber: string;
    employeeId:string
  };
  validatorDetails: ValidatorDetail[];
  assignedValidators: ValidatorDetail[];
  readingData: {
    currentReadingId: number;
    reasonCode: string | null;
    previousReasonCode: string | null;
    ruleStatus: string;
    previousReadingId: number;
    currentReading: number;
    previousReading: number;
    currentReadingImage: string | null;
    consumption: number;
    avgConsumption: number;
    currentReadingDate: string;
    previousReadingDate: string;
    totalDays: number;
    previousStatus: string;
    previousStatusCode: number;
    currentStatus: string;
    currentStatusCode: number;
    latitude: number | null;
    longitude: number | null;
    distance: number | null;
    locationGuidance: string;
    previousDirectionId: number | null;
    nextDirectionId: number;
    suspiciousActivity: string;
    oldSequence: string;
    newSequence: string;
    newMeter: string;
    location: string;
    remark: string;
    month: string;
    scheduleDate: string;
    additionalData: {
      illegalActivityRemark: string;
      illegalActivityPhoto: string;
      autoValidationRemark: string;
    };
    validationCode: string | null;
    currentReadingImages: ReadingImageItem[];
  };
  routeDetails: {
    id: number;
    routeName: string;
  };
  meterCycleDetails: {
    id: number;
    meterCycleName: string;
    readFormat:string;
    readFormatConfiguration:any;
  };
  meterRunDetails: {
    startDate: string;
    endDate: string;
  };
  summaryDetails: {
    total: number;
    completed: number;
    pending: number;
    revisit: number;
    fail: number;
  };
  premiseName: string;
  unitCodeInfo: any;
  areaName: string;
  subareaName: string;
  categoryName: string;
  subCategoryName: string;
  remoteMeterId: string;
  consumerNo: string;
  accountType: string;
  utilityService: string;
  firstName: string;
  lastName: string;
  consumerId: string;
  contactNumber: string;
  consumerStatus: string;
  email: string;
  address: string;
  exemptCode: string;
  additionalData: {
    [key: string]: string;
  };
  validatedBy: {
    validatorId: number;
    validatorName: string;
    email: string;
    contactNumber: string | null;
    validatedStatus: number;
    validationDate: string;
  };
}

export interface ConsumptionHistoryEntry {
  billMonth: string;
  meterReadPeriod: string | null;
  totalConsumption: number;
  days: number | null;
}

export interface MeterReadingConsumption {
  consumptionHistory: ConsumptionHistoryEntry[];
  avgConsumption: number;
}
export interface PreviousReadingImage {
  readingImage: string;
}

export interface ValidationCode {
  id: number;
  remoteUtilityId: number;
  code: string;
  name: string;
  remark: string | null;
  isActive: boolean;
  createdDate: string;
  createdUserRemoteName: string;
}
export interface ReasonCodeItem {
  id: number;
  remoteUtilityId: number;
  meterReadingStatus: {
    id: number;
    remoteUtilityId: number;
    codeId: number;
    name: string;
    reason: string;
    isActive: boolean;
    createdDate: string;
    createdUserRemoteName: string;
  };
  reasonCode: string;
  reason: string;
  isActive: boolean;
  createdDate: string;
}

export interface SOPList {
  id: number;
  name: string;
  shortName: string;
}

export interface ReadingSummaryPercentages {
  PASS: number;
  FAIL: number;
  PENDING: number;
  REVISIT: number;
  NEW: number;
  RCNT: number;
  FAULT: number;
  EXEMPTED: number;
  VALIDATED: number;
  FAULTY: number;
}

export interface ReadingSummary {
  Total: number;
  PASS: number;
  FAIL: number;
  PENDING: number;
  REVISIT: number;
  NEW: number;
  RCNT: number;
  FAULT: number;
  EXEMPTED: number;
  VALIDATED: number;
  PERCENTAGES: ReadingSummaryPercentages;
  FAULTY: number;
  dataTimeline: {
    startDate: string;
    endDate: string;
  };
}

export interface UserInfo {
  validatorId?: number;
  validatorName?: string;
  validatorType?: string;
  supervisorId?: number;
  supervisorName?: string;
  supervisorType?: string;
}

export interface ValidatorInfo {
  validatorId: number;
  validatorName: string;
  validatorType: string;
}

export interface SupervisorInfo {
  supervisorId: number;
  supervisorName: string;
  supervisorType: string;
}
export interface ActiveReadCycleResult {
  remoteUtilityId: string;
  meterCycleName: string;
  meterType: string;
  scheduleId: number;
  cycleId: number;
  runId: number;
  uniqueMeterCount: number;
  totalReadingCount: number;
  newReadingCount: number;
  exemptedCount: number;
  pass: number;
  fail: number;
  pending: number;
  revisit: number;
  new: number;
  createdDate: string;
  createdTime: string;
  createdMonth: string;
  rcnt: number;
  faulty: number;
  validationEnd: string;
  createdUserRemoteName: string | null;
  lastModifiedUserRemoteName: string | null;
  validatorInfo: ValidatorInfo[];
  supervisorInfo: SupervisorInfo[];
  collectedPercentage: number;
  pendingPercentage: number;
  validatedPercentage: number;
  exemptedPercentage: number;
  dueIn;
  productCode: string[];
  collectedCount: number;
  validatedCount: number;
  pendingCount: number;
}

export interface ActiveReadCycles {
  pageNumber: number;
  count: number;
  next: string | null;
  previous: string | null;
  results: ActiveReadCycleResult[];
}

//  -------- Validations ---------------
export interface RuleDetails {
  id: number;
  name: string;
  key: string;
  productCode: string;
  meterType: number;
  description: string;
  meterTypeDisplay: string;
  isActive: boolean;
  createdDate: string;
}

export interface ValidationRules {
  id: number;
  remoteUtilityId: number;
  rule: RuleDetails;
  label: string;
  description: string;
  createdDate: string;
  isActive: boolean;
}

export interface UserContact {
  id: number;
  name: string;
  email: string;
  contactNumber: string | null;
  userType: string;
}

export interface MeterCycleAllocation {
  id: number;
  meterCycleName: string;
  validators: UserContact[];
  supervisors: UserContact[];
}

export interface AuditUserMapResult {
  id: number;
  name: string;
}

export interface ValidationCodes {
  id: number;
  remoteUtilityId: number;
  code: string;
  name: string;
  remark: string | null;
  isActive: boolean;
  createdDate: string;
  createdUserRemoteName: string;
}

export const commonHeaders: TableColumn[] = [
  {
    key: "deviceNumber",
    header: "Serial No",
  },
  {
    key: "meterNumber",
    header: "Resource ID",
  },
  {
    key: "consumerName",
    header: "Consumer Name",
  },
  {
    key: "accountNumber",
    header: "Account Number",
  },
  {
    key: "previousReading",
    header: "Previous Reading",
  },
  {
    key: "meterReading",
    header: "Current Reading",
  },

  {
    key: "consumption",
    header: "Consumption",
  },
  {
    key: "ruleStatus",
    header: "Status",
    type: "badge",
    badgeConfig: {
      getVariant: (value: string) => {
        switch ((value || "").toLowerCase()) {
          case "active":
            return "default";
          case "pass":
            return "default";
          case "pending":
            return "default";
          case "inactive":
            return "secondary";
          case "maintenance":
            return "destructive";
          default:
            return "outline";
        }
      },
    },
    render: (value: string) => {
      switch ((value || "").toLowerCase()) {
        case "new":
          return "Pending";
        default:
          return value || "";
      }
    },
  },
];

// Exemptions Headers Configuration
export const exemptionsHeaders: TableColumn[] = [
  {
    key: "meterNumber",
    header: "Resource ID",
  },
  {
    key: "consumerName",
    header: "Consumer Name",
  },
  {
    key: "accountNumber",
    header: "Account Number",
  },
  {
    key: "meterReading",
    header: "Current Reading",
  },
  {
    key: "previousReading",
    header: "Previous Reading",
  },
  {
    key: "consumption",
    header: "Consumption",
  },
  {
    key: "validationCodeDisplay",
    header: "Validation Code",
    type: "badge",
  },
];

// Missing Reading Headers Configuration
export const missingReadingHeaders: TableColumn[] = [
  {
    key: "meterNumber",
    header: "Resource ID",
  },
  {
    key: "consumerName",
    header: "Consumer Name",
  },
  {
    key: "accountNumber",
    header: "Account Number",
  },
  {
    key: "previousReading",
    header: "Previous Reading",
  },
  {
    key: "createdDate",
    header: "Created Date",
  },
];

// New Reading Headers Configuration
export const newReadingHeaders: TableColumn[] = [
  {
    key: "deviceNo",
    header: "Serial No",
  },
  {
    key: "updatedOn",
    header: "Reading Date",
  },
  {
    key: "readingTime",
    header: "Reading Time",
  },
  {
    key: "meterReading",
    header: "Reading",
  },
  {
    key: "lat",
    header: "Latitude",
  },
  {
    key: "long",
    header: "Longitude",
  },
];

export const duplicateReadingHeaders: TableColumn[] = [
  {
    key: "meterNumber",
    header: "Resource ID",
  },
  {
    key: "consumerName",
    header: "Consumer Name",
  },
  {
    key: "accountNumber",
    header: "Account Number",
  },
  {
    key: "currentReading",
    header: "Current Reading",
  },
  {
    key: "previousReading",
    header: "Previous Reading",
  },
  {
    key: "duplicateReading",
    header: "Duplicate Reading",
  },
  {
    key: "duplicateStatus",
    header: "Duplicate Status",
  },
];
